module.exports = __webpack_public_path__ + "static/media/group-gifting-v2.e174905b.svg";